import React, { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Home() {
    const navigate = useNavigate();
    const { currentUser, tutorialCompleted } = useAuth();

    useEffect(() => {
        if (!currentUser) { // if user is not logged in
            navigate('/welcome');
        } else if (tutorialCompleted === false) { // if user has not done the tutorial
            navigate('/tutorial');
        } else navigate('/index');
    }, [tutorialCompleted, navigate, currentUser]);

    return (
        <></>
    );
}
